export default __webpack_public_path__ + "f1f318ddb938a51f6e40f1387fe7b2fc.png";